import { render } from "./Index.vue?vue&type=template&id=f311f62a&bindings={\"storageUsed\":\"options\",\"formatBytes\":\"options\",\"openNoticeModal\":\"options\",\"stats\":\"props\",\"activities\":\"props\",\"notices\":\"props\",\"can_view_stats\":\"props\",\"can_view_activities\":\"props\",\"can_view_notices\":\"props\",\"selectedNotice\":\"data\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f311f62a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f311f62a')) {
    api.reload('f311f62a', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=f311f62a&bindings={\"storageUsed\":\"options\",\"formatBytes\":\"options\",\"openNoticeModal\":\"options\",\"stats\":\"props\",\"activities\":\"props\",\"notices\":\"props\",\"can_view_stats\":\"props\",\"can_view_activities\":\"props\",\"can_view_notices\":\"props\",\"selectedNotice\":\"data\"}", () => {
    api.rerender('f311f62a', render)
  })

}

script.__file = "resources/js/Pages/Home/Index.vue"

export default script